:host {
  @apply block w-fit;
}

svg {
  @apply overflow-hidden max-w-full h-auto box-border align-middle;
}

progress {
  @apply block w-full h-[4px];
}

progress::-moz-progress-bar {
  @apply bg-berry;
}

progress::-webkit-progress-bar {
  @apply bg-grey-lighter rounded-sm;
}

progress::-webkit-progress-value {
  @apply bg-berry rounded-sm;
  transition: width 0.6s ease;
}
